import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from '../../utils/loadRoute';

/**
 * Single row in the Dashboard "Recent Loads" list.
 * Uses a CSS grid (not <tr>/<td>) so the Visual Editor Babel plugin can
 * safely wrap the .map() iteration with <span style="display:contents">
 * without violating HTML table-child validity (which was causing React
 * hydration warnings).
 */
export function RecentLoadRow({ load, status, isLast }) {
  const route = formatRoute(load);
  return (
    <Link
      to={`/loads/${load.id}`}
      className={`grid grid-cols-[80px_1fr_1.2fr_110px_110px] items-center gap-3 px-6 py-2.5 hover:bg-slate-50 transition-colors ${
        isLast ? '' : 'border-b border-slate-100'
      }`}
      data-testid={`load-row-${load.load_number}`}
    >
      <span className="text-sm font-medium text-blue-600 hover:text-blue-700 mono">
        {load.load_number}
      </span>
      <span className="text-sm text-slate-700 truncate">{load.customer_name}</span>
      <span className="text-xs text-slate-500 truncate" title={route || undefined}>
        {route || <span className="text-slate-400 italic">No route on file</span>}
      </span>
      <span>
        <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium ${status.bg} ${status.text}`}>
          {status.label}
        </span>
      </span>
      <span className="text-sm font-medium text-slate-900 mono text-right">
        ${(load.total_customer_rate ?? load.customer_rate)?.toLocaleString()}
      </span>
    </Link>
  );
}
